import { render, staticRenderFns } from "./anshin.vue?vue&type=template&id=ce6d58dc&"
import script from "./anshin.vue?vue&type=script&lang=js&"
export * from "./anshin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports